module.exports = __webpack_public_path__ + "static/media/ovh.da4d6c0c.svg";